<template>
    <h3
        class="mb-1 text-sm font-bold text-secondary"
        data-spec-class="card-title"
    >
        <slot />
    </h3>
</template>
